// HOW-SLOTS-WEB-AGENDA-TASKS (2026-07-09): tasks keyed by coordination-object id (same key space
// as agendaReducer), plus a flat personal rollup (`/users/me/tasks`, Home tasks card).
import actionTypes from "@actions/actionTypes"

export const initialState = {
  byCoId: {},
  myTasks: { loading: false, items: [] },
}

const coSlice = (state, coId) => state.byCoId[coId] || { loading: false, items: [], error: null }

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.TASKS_SET_LOADING: {
      const { coId, loading } = action.payload
      return {
        ...state,
        byCoId: { ...state.byCoId, [coId]: { ...coSlice(state, coId), loading } },
      }
    }
    case actionTypes.TASKS_SET_ITEMS: {
      const { coId, items } = action.payload
      return {
        ...state,
        byCoId: { ...state.byCoId, [coId]: { loading: false, items, error: null } },
      }
    }
    case actionTypes.TASK_UPSERTED: {
      const { coId, task } = action.payload
      const slice = coSlice(state, coId)
      const exists = slice.items.some(t => t.id === task.id)
      const items = exists
        ? slice.items.map(t => (t.id === task.id ? { ...t, ...task } : t))
        : [...slice.items, task]
      return { ...state, byCoId: { ...state.byCoId, [coId]: { ...slice, items } } }
    }
    case actionTypes.TASK_REMOVED: {
      const { coId, taskId } = action.payload
      const slice = coSlice(state, coId)
      return {
        ...state,
        byCoId: {
          ...state.byCoId,
          [coId]: { ...slice, items: slice.items.filter(t => t.id !== taskId) },
        },
      }
    }
    case actionTypes.MY_TASKS_SET_LOADING:
      return { ...state, myTasks: { ...state.myTasks, loading: !!action.payload } }
    case actionTypes.MY_TASKS_SET:
      return { ...state, myTasks: { loading: false, items: action.payload || [] } }
    default:
      return state
  }
}
